import { useNavigate } from "react-router-dom";

export const fetchAPI = async (
  method: string,
  url: string,
  body?: object | FormData,
  navigate?: ReturnType<typeof useNavigate>,
  customHeaders: Record<string, string> = {}
): Promise<any | null> => {
  try {
    // GET requesty nie powinny mieć body
    const isGetRequest = method.toUpperCase() === "GET";

    const defaultHeaders: Record<string, string> = {};
    if (!isGetRequest && body) {
      if (body instanceof FormData) {
        // FormData nie potrzebuje Content-Type - przeglądarka ustawi automatycznie
      } else {
        defaultHeaders["Content-Type"] = "application/json";
      }
    }

    const headers = { ...defaultHeaders, ...customHeaders };

    const fetchOptions: RequestInit = {
      method,
      headers,
      credentials: "include", // Wymagane dla sesji/CORS z cookies
    };

    // Tylko dodaj body jeśli to nie jest GET request
    if (!isGetRequest && body) {
      fetchOptions.body = body instanceof FormData ? body : JSON.stringify(body);
    }

    const response = await fetch(`${process.env.REACT_APP_API_URL}/${url}`, fetchOptions);

    console.log("Response status:", response.status);
    console.log("Response headers:", Object.fromEntries(response.headers.entries()));

    // Sprawdź Content-Type przed parsowaniem JSON
    const contentType = response.headers.get("content-type");
    const isJson = contentType && contentType.includes("application/json");

    // Pobierz tekst odpowiedzi (można wywołać tylko raz)
    const text = await response.text();

    console.log("Response text length:", text.length);
    console.log("Response text (first 200 chars):", text.substring(0, 200));

    // Sprawdź czy odpowiedź to HTML (częsty problem z routingiem SPA)
    if (text.trim().startsWith("<!") || text.includes("You need to enable JavaScript")) {
      console.error("Server returned HTML instead of JSON - routing issue detected");
      console.error("Response text (first 500 chars):", text.substring(0, 500));
      throw new Error("Serwer zwrócił HTML zamiast JSON. Sprawdź konfigurację .htaccess i ścieżkę API.");
    }

    // Sprawdź czy odpowiedź jest pusta
    if (text.trim().length === 0) {
      console.error("Empty response from server");
      console.error("Response status:", response.status);
      console.error("Response headers:", Object.fromEntries(response.headers.entries()));
      throw new Error("Serwer zwrócił pustą odpowiedź. Sprawdź logi błędów PHP na serwerze.");
    }

    let data;
    if (isJson && text) {
      try {
        data = JSON.parse(text);
        console.log("Response data:", data);
      } catch (parseError) {
        console.error("JSON parse error:", parseError);
        console.error("Response text:", text.substring(0, 500));
        throw new Error("Niepoprawna odpowiedź z serwera (nieprawidłowy JSON)");
      }
    } else if (!isJson) {
      // Jeśli odpowiedź nie jest JSON
      console.error("Non-JSON response:", text.substring(0, 500));
      throw new Error(
        `Serwer zwrócił nieprawidłowy format odpowiedzi (Content-Type: ${contentType}): ${response.status}`
      );
    } else {
      // Pusta odpowiedź JSON
      data = null;
    }

    if (response.status === 401) {
      console.log("Unauthorized access, redirecting to login");
      if (navigate) {
        navigate("/login");
      } else {
        window.location.href = "/login";
      }
      return null;
    }

    if (!response.ok) {
      console.log("Response not OK, throwing error");
      throw new Error(data?.message || `Błąd HTTP: ${response.status}`);
    }

    return data;
  } catch (error: any) {
    console.error("FetchAPI error:", error);
    console.error("Error details:", {
      name: error?.name || "Unknown",
      message: error?.message || "Unknown error",
      stack: error?.stack || "No stack trace",
    });
    return null;
  }
};
